import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import React from 'react';

import Container from '../design-system/Containers';
import PageWrapper from '../design-system/PageWrapper';
import PageSection from '../design-system/PageSection';
import { HeadingHero, HeadingSub } from '../design-system/Headings';
import { LinkButton } from '../design-system/Buttons';
import RadarHeroPageSection from '../design-system/RadarHeroPageSection';

import phrasesType from '../proptypes/phrases';

const SignUpPage = ({
  phrases,
  signInPath,
  visitorPath,
  spychologyPath,
}) => (
  <PageWrapper bgDark>
    <RadarHeroPageSection>
      <HeadingHero el="h1" pyLg>{phrases.title}</HeadingHero>
      <Container center py0 my0>
        <HeadingSub>{phrases.existingAccount.heading}</HeadingSub>
        <LinkButton w100 wmdf300 href={signInPath}>{phrases.existingAccount.button}</LinkButton>
      </Container>
    </RadarHeroPageSection>
    <PageSection pyXs>
      <Container center bgDarkMid>
        <HeadingSub>{phrases.visitor.heading}</HeadingSub>
        <LinkButton w100 wmdf300 secondary href={visitorPath}>{phrases.visitor.button}</LinkButton>
      </Container>
    </PageSection>
    <PageSection pyXs>
      <Container center bgDarkMid>
        <HeadingSub>{phrases.spychology.heading}</HeadingSub>
        <LinkButton w100 wmdf300 secondary href={spychologyPath}>
          {phrases.spychology.button}
        </LinkButton>
      </Container>
    </PageSection>
  </PageWrapper>
);

SignUpPage.propTypes = {
  phrases: phrasesType.isRequired,
  signInPath: PropTypes.string.isRequired,
  visitorPath: PropTypes.string.isRequired,
  spychologyPath: PropTypes.string.isRequired,
};

export default hot(SignUpPage);
